import { createAsyncThunk } from "@reduxjs/toolkit";
import { EApiMiddlewareMethods } from "../../../../network/networkHandler.types";
import customNetworHandler from "../../../../network/customNetworHandler";

/**
 * Factory to create an exportInvoicePdf thunk for a specific slice/service.
 * @param typePrefix - Unique Redux action type prefix (e.g. "RoutePlanning" or "ServiceB")
 * @param baseURL - The base URL of the target service
 */
export const createExportInvoicePdfThunk = (typePrefix: string, baseURL: string) =>
  createAsyncThunk(
    `${typePrefix}/ExportInvoicePdf`,
    async ({ params }: { params: any }, { rejectWithValue }) => {
      try {
        const request = {
          url: "/fulfilment/invoice/v4/view",
          method: EApiMiddlewareMethods.POST,
          data: params,
          responseType: "json",
          headers: { channel: "WEB" },
        } as any;
        const { data } = await customNetworHandler(request, baseURL);
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
